var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Translate, I18NLinkV2 as I18NLink } from "../../../../../I18N";
import { Button } from "../../../../Components/UI";











export const TemplatesEditorFooter = ({
  selected,
  onDelete,
  onSave,
  onAddThesaurus,
  onAddRelationshipType,
  onAddProperty,
  disableSave
}) => /*#__PURE__*/
_jsx("div", { className: "flex justify-between w-full" }, void 0, /*#__PURE__*/
_jsx("div", { className: "flex gap-2 items-center" }, void 0,
selected.length === 0 ? /*#__PURE__*/
React.createElement(React.Fragment, null, /*#__PURE__*/
_jsx(Button, { color: "primary", onClick: onAddProperty }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Add property")
), /*#__PURE__*/
_jsx(Button, { color: "primary", styling: "outline", onClick: onAddThesaurus }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Add thesaurus")
), /*#__PURE__*/
_jsx(Button, { color: "primary", styling: "outline", onClick: onAddRelationshipType }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Add relationship type")
)
) : /*#__PURE__*/

React.createElement(React.Fragment, null, /*#__PURE__*/
_jsx(Button, { color: "error", onClick: onDelete }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Remove")
), /*#__PURE__*/
_jsx("span", { className: "text-gray-700" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Selected"), " ", selected.length
)
)

), /*#__PURE__*/
_jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "/settings/templates" }, void 0, /*#__PURE__*/
_jsx(Button, { styling: "outline" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Cancel")
)
), /*#__PURE__*/
_jsx(Button, { color: "success", onClick: onSave, disabled: disableSave }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Save")
)
)
);